import React from 'react';

export default function KaizenInfoModal({ isOpen, setIsOpen }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                {/* Background overlay */}
                <div 
                    className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    onClick={() => setIsOpen(false)}
                ></div>

                {/* Modal panel */}
                <div className="relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                    <div className="bg-white px-6 py-6 sm:p-8">
                        {/* Header */}
                        <div className="flex items-center justify-between mb-6">
                            <h3 className="text-2xl font-bold text-gray-900">
                                About Kaizen FI
                            </h3>
                            <button
                                onClick={() => setIsOpen(false)}
                                className="rounded-md bg-white text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            >
                                <span className="sr-only">Close</span>
                                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        {/* Content */}
                        <div className="space-y-4 text-gray-700">
                            <p className="text-lg leading-relaxed">
                                Kaizen FI is about building financial independence step by step.
                            </p>
                            
                            <p className="leading-relaxed">
                                Instead of waiting for a distant "retire early" moment, Kaizen FI helps you see progress today — by covering your real-life expenses with income from your investments.
                            </p>
                            
                            <p className="leading-relaxed">
                                Each month, each habit, each small improvement moves you closer to independence.
                            </p>
                            
                            <p className="leading-relaxed">
                                You don't need to overhaul your life overnight — just keep making small, consistent upgrades in how you spend, save, and invest.
                            </p>
                            
                            
                                <p className="leading-relaxed">
                                    Inspired by the Japanese philosophy of Kaizen — continuous improvement — this approach turns financial independence into a living process, not a finish line.
                                </p>
                        
                            
                            <p className="leading-relaxed">
                                With Kaizen FI, you're not just tracking your money.
                            </p>
                            
                            <p className="leading-relaxed">
                                You're building financial independence, one expense at a time.
                            </p>
                        </div>

                        {/* Footer */}
                        <div className="mt-8 flex justify-end">
                            <button
                                onClick={() => setIsOpen(false)}
                                className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                                Got it!
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
